import { makeAutoObservable, toJS } from 'mobx';
import { storageHelper } from '@/utils';

class orderStore {

  constructor() {
    makeAutoObservable(this);
  }

  interceptCartList = (key: string, value: any) => {
    if (key === 'cartList') {
      storageHelper.setItem('__cart_list_v2', value);
      if (storageHelper.getItem('__cart_list')) {
        storageHelper.delete('__cart_list')
      }
    }
  }

  updateCart = (firstParams: any, callback?: any, propsValue = 'token') => {
    const { cartList } = this;
    let __cart_list = cartList ? [...cartList] : [];

    if (typeof firstParams === 'object') {
      __cart_list = firstParams;
    } else {
      const __index = __cart_list.findIndex((item: any) => item[propsValue] === `${firstParams}`);
      if (__index > -1) {
        __cart_list[__index] = typeof callback === 'function' ? callback(__cart_list[__index]) : callback;
      } else {
        __cart_list.push(typeof callback === 'function' ? callback?.() : callback);
      }
    }
    this.updateState({ cartList: __cart_list });
  }

  updateCartForIndex = (firstParams: { index: number, key?: any }, callback: any, propsValue = 'token') => {
    const { cartList } = this;
    const __cart_list = [...cartList];

    const { index, key } = firstParams;

    if (__cart_list[index]) {
      let __index = null;

      if (key) {
        __index = __cart_list.findIndex((item: any) => item[propsValue] === `${key}`);
      }

      /** 如果是改变购物车，并且找到了和改变后菜品相同的菜品，并且不只改变了当前菜品的数量 */
      if (__index !== null && __index > -1 && index !== __index) {
        this.mergeCartList(
          typeof callback === 'function' ?
            callback(__cart_list[__index]) :
            callback,
          __cart_list[__index],
          index,
          __index
        )
        return
      }
      /******************************************************* */

      if (__index !== null && __index > -1) {
        __cart_list[__index] = typeof callback === 'function' ? callback(__cart_list[__index]) : callback;
        // __cart_list.splice(__index, 1);
      } else {
        // __cart_list.splice(__index, 1);
        __cart_list[index] = typeof callback === 'function' ? callback(__cart_list[index]) : callback;
      }

    }
    this.updateState({ cartList: __cart_list });
  }

  deleteCart = (key?: string | number, propsValue = 'token') => {

    if (!key) {
      this.updateState({ cartList: [] });
      return;
    }

    const __index = this.cartList.findIndex((item: any) => item[propsValue] === key);

    const { cartList } = this;
    const __cart_list = [...cartList];
    if (__index > -1) {
      __cart_list.splice(__index, 1);
    }
    this.updateState({ cartList: __cart_list });
    
  }

  /** 修改购物车时的合菜逻辑 */
  mergeCartList = (originDish: any, targetDish: any, originIndex: string | number, targetIndex: string | number) => {
    let __originDish = {...originDish};
    const __cart_list = [...this.cartList];
    __originDish = {
      ...originDish,
      count: Number(targetDish?.count) + Number(originDish?.count),
      subTotalPrice: Number(targetDish?.subTotalPrice) + Number(originDish?.subTotalPrice)
    }
    __cart_list[targetIndex as number] = __originDish
    const curCartList = __cart_list.filter((_, cindex) => cindex !== originIndex)
    this.updateState({ cartList: curCartList });
  }
  /** **************** */

  updateState = (params: { [key: string]: any }) => {
    for (const [key, value] of Object.entries(params)) {
      this.interceptCartList(key, value);
      (this as any)[key] = value;
    }
  }

  
  deleteSpecificDish = (deleteDishIds:any) => {
    const { cartList } = this;
    if(cartList && cartList.length >0) {
      const filteredData = cartList.filter((item: DReqCheckoutCloud.ShoppingCartDish) => {
        const dishId = item.dishId as string | number | null | undefined;
        return dishId != null && !deleteDishIds.includes(dishId as string);
      });
      this.updateState({ cartList: filteredData });
    }
  
  }
  cartList: DReqCheckoutCloud.ShoppingCartDish[] = [];

}

export default new orderStore();